import { Box, Skeleton } from '@mui/material'
import React from 'react'

const TvContentSkeleton = () => (
    <Box display="flex" justifyContent="center" pt="20px">
        <Box mr="20px">
            <Skeleton
                sx={{
                    bgcolor: 'grey.800',
                    maxWidth: '965px',
                    maxHeight: '545px',
                    width: '100vw',
                    height: '100vh',
                }}
                animation="wave"
                variant="rectangular"
            />
            <Skeleton
                sx={{
                    bgcolor: 'grey.800',
                    maxWidth: '965px',
                    maxHeight: '200px',
                    width: '100vw',
                    height: '100vh',
                }}
                animation="wave"
                variant="rectangular"
            />
        </Box>
        <Box>
            {[...Array(20).keys()].map((index) => (
                <Skeleton
                    sx={{
                        bgcolor: 'grey.800',
                        maxWidth: '435px',
                        maxHeight: '63px',
                        width: '100vw',
                        height: '100vh',
                        mb: '20px',
                    }}
                    key={index}
                    animation="wave"
                    variant="rectangular"
                />
            ))}
        </Box>
    </Box>
)

export default TvContentSkeleton
